// File: components/academySectionsComponents/AcademyWorkWithLeadership.jsx

import React from "react";
import "./AcademyWorkWithLeadership.css";
import { useNavigate } from "react-router-dom";

import leadershipImage from "../../Assets/images/tobeused2.jpg";

export default function AcademyWorkWithLeadership() {

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact-us");
  };

  return (

    <section className="academy-work-section">

      <div className="academy-work-container">

        {/* Section Header */}
        <div className="academy-work-header">

          <h2>
            Working with Ample Academy
          </h2>

          <p>
            Develop leaders through immersive learning experiences.
          </p>

        </div>

        {/* Main Content */}
        <div className="academy-work-content-wrapper">

          {/* Left Image */}
          <div className="academy-work-image-wrapper">

            <div className="academy-work-image-glow"></div>

            <img
              src={leadershipImage}
              alt="AMPLE Leadership"
              className="academy-work-image"
            />

          </div>

          {/* Right Content */}
          <div className="academy-work-content">

            <p>
              Collaborate with Ample Academy to
              deliver immersive learning experiences
              that drive leadership excellence.
            </p>

            <button
              className="academy-work-btn"
              onClick={handleNavigate}
            >
              Learn More
            </button>

          </div>

        </div>

      </div>

    </section>

  );
}